var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 6 12"}},[_c('path',{attrs:{"d":"M 0.94335938,-0.00195313 0.16796875,0.62890625 4.5429688,6 0.171875,11.371094 0.94726562,12.001953 5.8320312,6 Z"}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }